<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'NavigationBreadcrumbs'
 * FIGMA: ''
 */
import type { NavigationBreadcrumbsProps } from '../types/interfaces'

import LinkBreadcrumb from './LinkBreadcrumb.vue'
import IconBreadcrumb from './IconBreadcrumb.vue'

defineOptions({
  name: 'NavigationBreadcrumbs',
})

defineProps<NavigationBreadcrumbsProps>()
</script>

<template>
  <nav class="nav-breadcrumbs">
    <template
      v-for="(item, index) in config"
      :key="Array.isArray(item) ? `group-${index}` : item.id"
    >
      <template v-if="Array.isArray(item)">
        <LinkBreadcrumb
          v-for="sub in item"
          :key="sub.id"
          :text="sub.text"
          :to="sub.to || ''"
          :disabled="sub.disabled"
        />
      </template>
      <LinkBreadcrumb
        v-else
        :text="item.text"
        :to="item.to || ''"
        :disabled="item.disabled"
      />
      <IconBreadcrumb />
    </template>
  </nav>
</template>

<style lang="scss" scoped src="../styles/_navigation-breadcrumbs.scss" />